import { render, staticRenderFns } from "./sceneView.vue?vue&type=template&id=1be4eca0&scoped=true"
import script from "./sceneView.vue?vue&type=script&lang=js"
export * from "./sceneView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be4eca0",
  null
  
)

export default component.exports